/**
 * @file IconTopping Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-topping',
  (data) => `
<svg width="${data.size}" height="${data.size}" fill="none" viewBox="0 0 8 8">
  <defs>
    <clipPath><rect width="8" height="8" x="0" y="0" rx="0" /></clipPath>
  </defs>
  <g clip-path="url(#master_svg0_9_1239)">
    <g>
      <path
        fill="${data.colorDesc[0]}"
        fill-opacity="1"
        d="M2.41421,0C1.52331,0,1.07714,1.07714,1.70711,1.70711L6.29289,6.29289C6.92286,6.92286,8,6.47669,8,5.58579L8,1C8,0.447715,7.55228,0,7,0L2.41421,0Z"
      />
    </g>
  </g>
</svg>
`
);
